The phone number of a person.
